/**
 * Search Bar Vue Component
 * ------------------------------------------------------------------------------
 * Template in snippets/header-search.liquid
 *
 */

import axios from 'axios'
import debounce from 'lodash-es/debounce'
import ProductItem from './product-item'
import { productMetafieldsQuery } from '../utils/data'
import { storefrontRequestConfig } from '../utils/api'

import { app } from '../vue/app.js'

export default {
  components: {
    ProductItem
  },

  props: {
    defaultValue: {
      type: String,
      default: null
    },
    isSearchOpen: {
      type: Boolean
    }
  },

  data () {
    return {
      isSearchLoading: false,
      search: this.defaultValue,
      results: [],
      hasNoResults: false
    }
  },

  watch: { // Debounce and watchers - https://vuejs.org/v2/guide/computed.html#Watchers
    search (value) {
      if (value) {
        this.debouncedPerformSearch()
      } else {
        this.results = []
      }
    },

    isSearchOpen (value) {
      if (value) {
        document.querySelector('body').classList.add('no-scroll')
        this.$nextTick(() => {
          this.$refs.search.focus()
        })

        if (this.search && !this.results.length) this.debouncedPerformSearch()
      } else {
        document.querySelector('body').classList.remove('no-scroll')
      }
    }
  },

  created () {
    this.debouncedPerformSearch = debounce(this.performSearch, 500)
  },

  methods: {
    toggleSearch () {
      app.toggleSearch()
    },

    async performSearch () {
      this.isSearchLoading = true
      this.hasNoResults = false

      if (this.search) {
        // Predictive Search API - https://shopify.dev/docs/themes/ajax-api/reference/predictive-search
        await axios.get(`/search/suggest?q=${this.search}&resources[type]=product&resources[limit]=8&section_id=predictive-search`).then(({ data }) => {
          const el = document.createElement('div')
          el.innerHTML = data

          this.results = JSON.parse(el.querySelector('#shopify-section-predictive-search').innerHTML)

          if (this.results < 1) this.hasNoResults = true
          else {
            const graphqlIds = this.results.map(product => {
              return '"' + btoa('gid://shopify/Product/' + product.id) + '"'
            })

            const data = `{
              nodes(ids: [${graphqlIds}]) {
                id
                ... on Product {
                  ${productMetafieldsQuery}
                }
              }
            }`

            // eslint-disable-next-line no-undef
            axios.post(`https://${Shopify.shop}/api/2024-07/graphql`, data, storefrontRequestConfig).then(({ data }) => {
              this.results = this.results.map((result) => {
                const graphqlNode = data.data.nodes[this.results.indexOf(result)]

                const isWelcomeDw = result.tags?.some(tag =>
                  tag.toLowerCase().includes('welcomedw')
                ) || false

                return {
                  ...result,
                  review: graphqlNode?.rating?.value.split(':')[3].replace('"', '').replace('}', '').replace('"', ''),
                  promotionalPrice: parseInt(graphqlNode?.promotionalPrice?.value) * 100 || null,
                  isWelcomeDw
                }
              })
            })
          }
        }).catch((error) => {
          console.log(error)
        })
      }

      this.isSearchLoading = false
    }
  }
}
